import * as React from 'react';
import { NavLink, RouteComponentProps, withRouter } from 'react-router-dom';

import AuthService from '../../services/AuthService';
import FlashStore from '../../services/FlashStore';
import { Nav } from '../../modules/modules';
import CountryService from '../../services/CountryService';
import { callAuthorizeBackend } from '../../helpers/backend/callAuthorizeBackend';
interface IUserWrapProps extends RouteComponentProps<{ language: string }> {
  
}

class UserWrap extends React.Component<IUserWrapProps> {
  state = {
    generating: false,
  };
 
  constructor(props: IUserWrapProps) {
    super(props);
    if (!AuthService.GetInstance().loggedIn) {
      const { countryCode } = CountryService.GetInstance();
      FlashStore.GetInstance().showMessage(`You don't have access to this page`, 'error');
      this.props.history.push(`/${countryCode}`);
    }
  }

  handleDownloadB2BPricelist = () => {
    const currency = CountryService.GetInstance().currency;
    // volání backendu
    this.setState({
      generating: true,
    }, () => {
      callAuthorizeBackend({
        path: '/products/pricelist/b2b',
        data: {
          currency: currency && currency.value,
        },
        method: 'POST',
        executeDownload: true,
        onSuccess: () => {
          this.setState({
            generating: false
          });
        },
        onError: () => {
          this.setState({
            generating: false
          });
        }
      });
    });
  }

  public render() {
    const { countryCode } = CountryService.GetInstance();
    const auth = AuthService.GetInstance();
    const { customer } =  auth;

    let customerSections: any[] = [];
    const customerGroups = (customer && customer.customerGroups);
    if (customerGroups) {
      customerSections = customerGroups.filter((cg: any) => !!cg.description);
    }

    return (
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <Nav type="user">
              <div className="nav__item">
                {/* Country code urls are not used anymore
                <NavLink to={`/${countryCode}/user/orders`} className="nav__link"> */}
                <NavLink to={`/user/orders`} className="nav__link">
                  Orders
                </NavLink>
              </div>
              <div className="nav__item">
                {/* Country code urls are not used anymore
                <NavLink to={`/${countryCode}/user/data`} className="nav__link"> */}
                <NavLink to={`/user/data`} className="nav__link">
                  Personal data
                </NavLink>
              </div>
              <div className="nav__item">
                {/* Country code urls are not used anymore
                <NavLink to={`/${countryCode}/user/password`} className="nav__link"> */}
                <NavLink to={`/user/password`} className="nav__link">
                  Change password
                </NavLink>
              </div>
              {auth.customer && auth.customer.discount && <div className="nav__item">
                <NavLink to={`/${countryCode}/user/export-pricelist`} /* onClick={this.handleDownloadB2BPricelist} */ className="nav__link">
                  Export pricelist
                </NavLink>
              </div> || ''}
              {customerSections && customerSections.map((customerGroup: any) => 
                <div key={customerGroup.id} className="nav__item">
                    {/* Country code urls are not used anymore
                    <NavLink to={`/${countryCode}/user/group/${customerGroup.id}`} className="nav__link"> */}
                    <NavLink to={`/user/group/${customerGroup.id}`} className="nav__link">
                    {customerGroup.name}
                  </NavLink>
                </div>)}
              <div className="nav__item logout">
                <NavLink 
                  // Country code urls are not used anymore
                  // to={`/${countryCode}`} 
                  to={'/'} 
                  className="nav__link" 
                  onClick={(e: any) => {
                    auth.removeToken();
                  }}
                >
                  Logout
                </NavLink>
              </div>
            </Nav>
          </div>
          <div className="col-md-9">
            {this.props.children}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(UserWrap);



// WEBPACK FOOTER //
// ./src/components/UserWrap/UserWrap.tsx